import { writable } from "svelte/store";

export const cat = writable(0);
export const dog = writable(0);
